import { render, staticRenderFns } from "./FIntersectionObserver.vue?vue&type=template&id=fb6a4e48&scoped=true&"
import script from "./FIntersectionObserver.vue?vue&type=script&lang=js&"
export * from "./FIntersectionObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a4e48",
  null
  
)

export default component.exports